var de = {
	'选单':'Menü',
	'搜索':'Search',
	'关闭':'Close',
	'没有结果，请输入其他关键字':'Keine Ergebnisse, bitte andere Keywords eingeben',
	'手表系列':'Uhrenserie',
	'新闻模块':'Nachrichtenmodul',
	'防伪检测':'Erkennung und Kontakt gegen Fälschungen',
	'关注':'Folgen',
	'成为我们的一员':'Werde einer von uns',
	'打开微信扫一扫':'WeChat zum Scannen öffnen',
	'关于品牌':'Über Marke',
	'全部手表':'Alle Uhren',
	'探索':'Explore',
	'巴博斯腕表':'Jingli Armbanduhr',
	'品牌与帆船运动界的深厚渊源，最早可追溯至1950年代。启发自此悠久传统，游艇名仕型腕表集实用功能与非凡风格于一身，而游艇名仕型 II计时腕表则为劳力士超卓技术结晶，专为帆船赛计时而设计。':'Die tiefe Beziehung zwischen der Marke und der Segelindustrie lässt sich bis in die 1950er Jahre zurückverfolgen. Inspiriert von dieser langen Tradition verbindet die Yacht Mingshi Uhr praktische Funktionen mit außergewöhnlichem Stil, während die Yacht Mingshi II Uhr ein Produkt der hervorragenden Technologie von Rolex ist, die für das Timing von Segelereignissen entwickelt wurde',
	'防伪监测文案':'Kopie zur Überwachung von Fälschungen',
	'游艇名仕型结合非凡风格与性能，从容应对海中或船上的各种场合。凭借其防水和坚固特质，成为水上运动以至扬帆出海的腕表之选。':'Yacht Mingshi kombiniert außergewöhnlichen Stil und Leistung, um mit verschiedenen Anlässen im Meer oder auf dem Schiff ruhig umzugehen. Mit seinen wasserdichten und robusten Eigenschaften ist es zur Wahl von Uhren für Wassersport und sogar Segeln geworden',
	'甄别自己':'Sich identifizieren',
	'联系我们':'Kontakt',
	'查看新闻':'View News',
	'探寻附近门店':'Explore nearby stores',
	'品牌新闻':'Brand News',
	'全部':'Alle',
	'防伪检测查询':'Abfrage zur Erkennung von Fälschungen',
	'输入防伪码':'Sicherheitscode eingeben',
	'输入20位纯数字校验':'Input 20-stellige Reinstell-Verifizierung',
	'查询':'Abfrage',
	'商品不正确':'Artikel falsch',
	'商品为正版':'Waren sind echt',
	'重新测试':'Retest',
	'联系电话':'Kontakttelefon',
	'联系邮箱':'Kontakt-E-Mail',
	'探索尊贵非凡且精准可靠的巴博斯腕表':'Entdecken Sie die distinguierten, genauen und zuverlässigen Jingli Uhren',
	'一系列图集':"A series of atlases",
	'技术规格':'Technische Spezifikationen',
	'其他推荐':'Sonstige Empfehlungen',
	'巴博斯腕表精品店':'Jingli Wrist Watch Boutique',
	'凭借丰富经验及专业知识，竭诚助您选购可伴随一生的时计。':'Mit reicher Erfahrung und Fachwissen helfen wir Ihnen von ganzem Herzen, eine lebenslange Uhr auszuwählen und zu kaufen',
	'备注文案、欢迎语等。':'Anmerkungen Kopie, Begrüßungsnachricht usw.',
	'暂无数据':'Temporär keine Daten',
	'请输入关键字':'Bitte Schlüsselwörter eingeben',
	'服务中心':'Service Center',
	'使用条款':'Nutzungsbedingungen',
	'隐私协议':'Datenschutzvereinbarung',
	'新闻详情':'News details',
	'当前为该语言无需切换':'Die aktuelle Sprache muss nicht umgeschaltet werden',
	'上一条':'Früher',
	'查看更多':'Mehr anzeigen',
	'下一条':'Weiter',
	'已经是第一篇了':'Es ist das erste Kapitel',
	'没有下一篇了':'Es gibt keinen nächsten Artikel',
	'巴博斯精品推荐':'Jingli Boutique Empfehlung',
	'型号':'Modell',
	'欢迎来到JINLERY巴博斯腕表店':'Willkommen bei JINLERY Jingli Watch Shop',
	'专业设计、科技创新、力求上进':'Professionelles Design, wissenschaftliche und technologische Innovation, Streben nach Fortschritt',
	'首页':'Home',
	'您好，您所查询的是由巴博斯品牌生产的德国手表，该产品经验证为正品。':'Hallo, was Sie fragen ist eine Schweizer Uhr der Marke Jingli, die als authentisch verifiziert wurde.',
	'了解更多款式':'Weitere Stile erfahren'
}
export default de